import { KEY } from './weather-key';

export const URL_WEATHER = (townName) =>
    `https://api.openweathermap.org/data/2.5/weather?q=${townName},ua&lang=ua&units=metric&appid=${KEY}`;

export const URL_WEATHER_LOCATION = (lat, lon) =>
    `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&lang=ua&units=metric&appid=${KEY}`;

export const URL_FIVE_DAYS = (townName) =>
    `https://api.openweathermap.org/data/2.5/forecast?q=${townName}&units=metric&lang=ua&appid=${KEY}`;

export const LOCATION_JSON = 'https://ipapi.co/json/';

export const URL_GET_UANAME = (townName) =>
    `https://api.openweathermap.org/geo/1.0/direct?q=${townName},ua&limit=1&appid=${KEY}`;

export const URL_POLLUTION = (lat, lon) =>
    `https://api.openweathermap.org/data/2.5/air_pollution?lat=${lat}&lon=${lon}&appid=${KEY}`;
